/* eslint-disable no-bitwise */

/* this segment copied from node:net */
// IPv4 Segment
const v4Seg = '(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])';
const v4Str = `(?:${v4Seg}\\.){3}${v4Seg}`;
const IPv4Reg = new RegExp(`^${v4Str}$`);

// IPv6 Segment
const v6Seg = '(?:[0-9a-fA-F]{1,4})';
const IPv6Reg = new RegExp(
  '^(?:' +
    `(?:${v6Seg}:){7}(?:${v6Seg}|:)|` +
    `(?:${v6Seg}:){6}(?:${v4Str}|:${v6Seg}|:)|` +
    `(?:${v6Seg}:){5}(?::${v4Str}|(?::${v6Seg}){1,2}|:)|` +
    `(?:${v6Seg}:){4}(?:(?::${v6Seg}){0,1}:${v4Str}|(?::${v6Seg}){1,3}|:)|` +
    `(?:${v6Seg}:){3}(?:(?::${v6Seg}){0,2}:${v4Str}|(?::${v6Seg}){1,4}|:)|` +
    `(?:${v6Seg}:){2}(?:(?::${v6Seg}){0,3}:${v4Str}|(?::${v6Seg}){1,5}|:)|` +
    `(?:${v6Seg}:){1}(?:(?::${v6Seg}){0,4}:${v4Str}|(?::${v6Seg}){1,6}|:)|` +
    `(?::(?:(?::${v6Seg}){0,5}:${v4Str}|(?::${v6Seg}){1,7}|:))` +
    ')(?:%[0-9a-zA-Z-.:]{1,})?$',
);

function isIPv4(s: string) {
  return IPv4Reg.exec(s);
}

function isIPv6(s: string) {
  return IPv6Reg.exec(s);
}

function isIP(s: string): 0 | 4 | 6 {
  if (isIPv4(s)) return 4;
  if (isIPv6(s)) return 6;
  return 0;
}
/* end segment copied from node:net */

function ipToInt(ip: string): number {
  return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0;
}

function intToIP(int: number): string {
  return [(int >>> 24) & 255, (int >>> 16) & 255, (int >>> 8) & 255, int & 255].join('.');
}

/** Returns true if the address is a CIDR range */
export function isCIDR(address: string): boolean {
  return address.includes('/');
}

/**
 * expands a CIDR range into a string array of all IPs in that range. Only
 * supports IPv4 CIDRs
 */
export function expandCIDR(cidr: string): string[] {
  const [ip, prefixStr] = cidr.split('/');
  const prefix = parseInt(prefixStr, 10);

  if (!isIP(ip) || isNaN(prefix) || prefix < 0 || prefix > 32) {
    throw new Error(`Invalid CIDR notation: ${cidr}`);
  }

  const hostBits = 32 - prefix;
  const numHosts = 2 ** hostBits;
  const networkInt = ipToInt(ip) & (0xffffffff << hostBits);

  const ips: string[] = [];
  for (let i = 0; i < numHosts; i += 1) {
    const hostInt = networkInt + i;
    ips.push(intToIP(hostInt));
  }

  return ips;
}
